export const catalog = {
    title: 'Catalog',
    products: 'Products',
    categories: {
        title: 'Categories',
        all: 'All',
        new: 'New Drones',
        used: 'Used Drones',
        buffalo: 'Buffalo Line',
        'power-citros': 'Power Citros',
        parts: 'Parts & Accessories',
    },
    noProducts: 'No products found',
    noCategories: 'No categories found',
    viewProduct: 'View product',
    addToCart: 'Add to cart',
    productDetails: 'Product details',
    description: 'Description',
    specifications: 'Specifications',
    reviews: 'Reviews',
    relatedProducts: 'Related products',
    searchPlaceholder: 'Search products...',
    filterBy: 'Filter by',
    sortBy: 'Sort by',
    clearFilters: 'Clear Filters',
    sortOptions: {
        priceAsc: 'Price: low to high',
        priceDesc: 'Price: high to low',
        nameAsc: 'Name: A-Z',
        nameDesc: 'Name: Z-A',
        newest: 'Newest',
        oldest: 'Oldest',
    },
    results: {
        showing: 'Showing',
        of: 'of',
        results: 'results',
    },
    pagination: {
        ariaLabel: 'Pagination navigation',
        previous: 'Previous',
        next: 'Next',
        page: 'Page {{page}}',
    },
};
//# sourceMappingURL=catalog.js.map